import React from "react";
import client from "lib/ApolloClient";
import { ApolloProvider, Query } from "react-apollo";
import gql from "graphql-tag";
import { autobind } from "react-decoration";
import qs from "query-string";
import navigate from "lib/navigate";
import ReactLoading from "react-loading";
import { inject, observer } from "mobx-react";
import ResourceGroupLightBox2 from "components/resource/ResourceGroupLightBox2";
import ReactHtmlParser from "react-html-parser";

const getDBResourceQueryGroup = gql`
  query getDBResourceQueryGroup($searchForm: SearchForm) {
    getDBResourceQueryGroup(Input: $searchForm) {
      queryGroupList {
        title
        index
        list {
          cnt
          title
          value
        }
      }
      propertyList {
        sn
      }
      cooperationList {
        sn
      }
      applicableList {
        sn
      }
      sourceList {
        sn
      }
      showStatus
    }
  }
`;

@inject("appStore")
@observer
class DBResourceQueryGroupComp2 extends React.Component {
  constructor(props) {
    super(props);
    let statusItemString =
      props.appStore.globalConfig["jumper.erm.databases.limiter.statusItem"] ||
      "";
    let queryGroupOrderString =
      props.appStore.globalConfig["jumperrwd.queryGroup.dbResourceOrder"] || "";
    let statusItem = {};
    if (statusItemString !== "") {
      statusItem = JSON.parse(statusItemString);
    }
    let queryGroupOrderList = [
      "status",
      "property",
      "cooperation",
      "applicable",
      "source",
      "class",
    ];
    if (queryGroupOrderString !== "") {
      queryGroupOrderList = JSON.parse(queryGroupOrderString);
    }
    this.state = {
      auth: props.readerStore.auth,
      showFilter: false,
      refetch: null,
      closeList: [],
      statusItem,
      queryGroupOrderList,
    };
  }

  UNSAFE_componentWillReceiveProps(props) {
    if (this.state.auth !== props.readerStore.auth) {
      this.setState({ auth: props.readerStore.auth });
      if (this.state.refetch !== null && this.state.refetch !== undefined) {
        this.state.refetch();
      }
    }
    if (props.showFilter !== this.state.showFilter) {
      if (props.showFilter) {
        this.setState({ showFilter: true }, () => {
          setTimeout(() => {
            if (this.closeButton) {
              this.closeButton.focus();
            }
          }, 10);
        });
      } else {
        this.setState({ showFilter: false });
      }
    }
  }

  @autobind
  setFilter(ff, fv, e) {
    e.preventDefault();
    if (ff !== "" && fv !== "") {
      let { search, location } = this.props;
      let params = { ...search };
      let { filterField, filterValue } = params;
      filterField = [].concat(filterField || []);
      filterValue = [].concat(filterValue || []);
      filterField.push(ff);
      filterValue.push(fv);
      params.filterField = filterField;
      params.filterValue = filterValue;
      delete params.pageNo;
      navigate([location.pathname, qs.stringify(params)].join("?"));
    }
    if (this.state.showFilter) {
      this.props.changeShowFilter(false);
    }
  }

  @autobind
  delAllFilter(e) {
    e.preventDefault();
    let { search, location } = this.props;
    let params = { ...search };
    delete params.filterField;
    delete params.filterValue;
    delete params.pageNo;
    navigate([location.pathname, qs.stringify(params)].join("?"));
    if (this.state.showFilter) {
      this.props.changeShowFilter(false);
    }
  }

  @autobind
  delFilter(field, value, e) {
    e.preventDefault();
    let { search, location } = this.props;
    let params = { ...search };
    let { filterField, filterValue } = params;
    filterField = [].concat(filterField || []);
    filterValue = [].concat(filterValue || []);
    let newFilterField = [];
    let newFilterValue = [];
    filterField.map((v, k) => {
      if (v !== field || filterValue[k] !== value) {
        newFilterField.push(v);
        newFilterValue.push(filterValue[k]);
      }
      return "";
    });
    if (newFilterField.length > 0) {
      params.filterField = newFilterField;
      params.filterValue = newFilterValue;
    } else {
      delete params.filterField;
      delete params.filterValue;
    }
    navigate([location.pathname, qs.stringify(params)].join("?"));
    if (this.state.showFilter) {
      this.props.changeShowFilter(false);
    }
  }

  @autobind
  makeFilterMap(filterField, filterValue) {
    let filterMap = {};
    let filterFieldList = [].concat(filterField || []);
    let filterValueList = [].concat(filterValue || []);
    filterFieldList.map((field, k) => {
      if (field === "class") {
        let values = filterValueList[k].split(":");
        let filterClassMap = filterMap.class || {};
        let filterClassList = [].concat(filterMap.classList || []);
        filterClassList.push(filterValueList[k]);
        let valueList = [].concat(filterClassMap[values[0]] || []);
        valueList.push(values[1]);
        filterClassMap[values[0]] = valueList;
        filterMap.class = filterClassMap;
        filterMap.classList = filterClassList;
      } else {
        let valueList = [].concat(filterMap[field] || []);
        valueList.push(filterValueList[k]);
        filterMap[field] = valueList;
      }
      return "";
    });
    return filterMap;
  }

  @autobind
  openResourceGroupLightBox(type) {
    if (this.queryGroup.refs[type + "GroupLightBox"]) {
      this.queryGroup.refs[type + "GroupLightBox"].popup();
    }
  }

  @autobind
  changeQueryGroupClose(isClose, name, e) {
    e.preventDefault();
    if (isClose) {
      var closeList = [...this.state.closeList];
      var index = closeList.indexOf(name);
      if (index !== -1) {
        closeList.splice(index, 1);
        this.setState({ closeList });
      }
    } else {
      let closeList = [...this.state.closeList];
      closeList.push(name);
      this.setState({ closeList });
    }
  }

  render() {
    let { statusItem, queryGroupOrderList } = this.state;
    let { t, searchForm, appStore, showList } = this.props;
    let { globalConfig } = appStore;
    let { filterField, filterValue } = searchForm;
    let filterMap = this.makeFilterMap(filterField, filterValue);
    let filterFieldList = [].concat(filterField || []);
    let { dbResourceCount } = appStore;
    let showQueryGroup = showList && dbResourceCount > 0;
    let form = { ...searchForm };
    delete form["limit"];
    delete form["pageNo"];

    let colLeftStyle = { transition: "opacity 1s" };
    if (this.state.showFilter) {
      colLeftStyle = {
        opacity: 1,
        transition: "opacity 1s",
        display: "block",
        marginTop: 0,
      };
    }

    return (
      <>
        <div className="col-left refine" style={colLeftStyle}>
          <a
            className="accesskey"
            href="javascript:;"
            id="aL"
            accessKey="L"
            title={this.props.t("jumperrwd.common.leftSideArea")}>
            :::
          </a>
          <h2 className="secHead1">
            {t("jumperrwd.common.adjustQuery")}
            <button
              type="button"
              tabIndex="0"
              ref={(c) => (this.closeButton = c)}
              className="close"
              title={t("jumperrwd.common.close")}
              aria-label={t("jumperrwd.common.close")}
              onClick={(e) => {
                e.preventDefault();
                this.props.changeShowFilter(false);
              }}></button>
          </h2>
          {filterFieldList.length > 0 && (
            <section className="conditionList">
              <h3 className="secHead3">{t("jumper.common.limiter.tips")}</h3>
              {Object.keys(filterMap).map((key) => {
                if (key === "source") {
                  return (
                    <>
                      <h4>{t("jumper.common.limiter.status")}</h4>
                      <ul>
                        {filterMap[key].map((value) => {
                          let name = "";
                          if (value === "4") {
                            name = t("jumper.common.limiter.trial");
                          } else if (value === "news") {
                            name = t("jumper.common.limiter.news");
                          } else if (value === "2") {
                            name = t("jumper.common.limiter.order");
                          } else if (value === "1") {
                            name = t("jumper.common.limiter.free");
                          } else if (value === "core") {
                            name = t("jumper.common.limiter.core");
                          } else if (value === "publicLibrary") {
                            name = t("jumperrwd.common.publicLibrary");
                          } else if (value === "fulltext") {
                            name = t("jumper.common.searchall");
                          } else if (value === "maintain") {
                            name = t("hyint.esource.maintain");
                          } else {
                            name = t("jumperrwd.source.name." + value);
                          }
                          return (
                            <li>
                              {name}
                              <button
                                type="button"
                                tabIndex="0"
                                className="icon-remove"
                                onClick={this.delFilter.bind(
                                  this,
                                  "source",
                                  value,
                                )}
                                aria-label={t(
                                  "jumperrwd.common.delete",
                                )}></button>
                            </li>
                          );
                        })}
                      </ul>
                    </>
                  );
                } else if (key === "property") {
                  return (
                    <>
                      <h4>{t("jumper.common.limiter.property")}</h4>
                      <ul>
                        {filterMap[key].map((value) => {
                          return (
                            <li>
                              {t("jumperrwd.property.name." + value)}
                              <button
                                type="button"
                                tabIndex="0"
                                className="icon-remove"
                                onClick={this.delFilter.bind(
                                  this,
                                  "property",
                                  value,
                                )}
                                aria-label={t(
                                  "jumperrwd.common.delete",
                                )}></button>
                            </li>
                          );
                        })}
                      </ul>
                    </>
                  );
                } else if (key === "cooperation") {
                  return (
                    <>
                      <h4>{t("jumper.common.limiter.cooperation")}</h4>
                      <ul>
                        {filterMap[key].map((value) => {
                          return (
                            <li>
                              {t("jumperrwd.cooperation.name." + value)}
                              <button
                                type="button"
                                tabIndex="0"
                                className="icon-remove"
                                onClick={this.delFilter.bind(
                                  this,
                                  "cooperation",
                                  value,
                                )}
                                aria-label={t(
                                  "jumperrwd.common.delete",
                                )}></button>
                            </li>
                          );
                        })}
                      </ul>
                    </>
                  );
                } else if (key === "platform") {
                  return (
                    <>
                      <h4>{t("jumperrwd.common.limiter.platform")}</h4>
                      <ul>
                        {filterMap[key].map((value) => {
                          return (
                            <li>
                              {t("jumperrwd.platform.name." + value)}
                              <button
                                type="button"
                                tabIndex="0"
                                className="icon-remove"
                                onClick={this.delFilter.bind(
                                  this,
                                  "platform",
                                  value,
                                )}
                                aria-label={t(
                                  "jumperrwd.common.delete",
                                )}></button>
                            </li>
                          );
                        })}
                      </ul>
                    </>
                  );
                } else if (key === "applicable") {
                  return (
                    <>
                      <h4>{t("jumperrwd.common.applicable")}</h4>
                      <ul>
                        {filterMap[key].map((value) => {
                          return (
                            <li>
                              {t("jumperrwd.applicable.name." + value)}
                              <button
                                type="button"
                                tabIndex="0"
                                className="icon-remove"
                                onClick={this.delFilter.bind(
                                  this,
                                  "applicable",
                                  value,
                                )}
                                aria-label={t(
                                  "jumperrwd.common.delete",
                                )}></button>
                            </li>
                          );
                        })}
                      </ul>
                    </>
                  );
                } else if (key === "class") {
                  let list = [];
                  Object.keys(filterMap.class).map((key2) => {
                    list.push(
                      <>
                        <h4>
                          {ReactHtmlParser(t("jumperrwd.class.name." + key2))}
                        </h4>
                        <ul>
                          {filterMap.class[key2].map((value) => {
                            return (
                              <li>
                                {ReactHtmlParser(
                                  t("jumperrwd.class.name." + value),
                                )}
                                <button
                                  type="button"
                                  tabIndex="0"
                                  className="icon-remove"
                                  onClick={this.delFilter.bind(
                                    this,
                                    "class",
                                    key2 + ":" + value,
                                  )}
                                  aria-label={t(
                                    "jumperrwd.common.delete",
                                  )}></button>
                              </li>
                            );
                          })}
                        </ul>
                      </>,
                    );
                    return "";
                  });
                  return list;
                }
                return "";
              })}
              <button
                type="button"
                tabIndex="0"
                className="btn-icon-delete"
                onClick={this.delAllFilter.bind(this)}>
                {t("jumperrwd.common.clearAll")}
              </button>
            </section>
          )}
          {showQueryGroup && (
            <ApolloProvider client={client.jumperrwdClient}>
              <Query
                query={getDBResourceQueryGroup}
                fetchPolicy="network-only"
                ref={(c) => {
                  this.queryGroup = c;
                }}
                variables={{
                  searchForm: form,
                }}>
                {({ loading, error, data, refetch }) => {
                  if (loading)
                    return (
                      <div style={{ textAlign: "center" }}>
                        <ReactLoading
                          type="cylon"
                          height={"10%"}
                          width={"20%"}
                          color="#005D98"
                        />
                      </div>
                    );
                  if (error) return `Error!${error.message}`;
                  if (this.state.refetch === null) {
                    this.setState({ refetch: refetch });
                  }
                  if (data.getDBResourceQueryGroup) {
                    let {
                      queryGroupList,
                      propertyList,
                      cooperationList,
                      applicableList,
                      sourceList,
                      showStatus,
                    } = data.getDBResourceQueryGroup;
                    let sourceFilterList = [].concat(filterMap.source || []);
                    let propertyFilterList = [].concat(
                      filterMap.property || [],
                    );
                    let cooperationFilterList = [].concat(
                      filterMap.cooperation || [],
                    );
                    let applicableFilterList = [].concat(
                      filterMap.applicable || [],
                    );
                    let classFilterList = [].concat(filterMap.classList || []);
                    let propertyShowFlag = 0;
                    let cooperationShowFlag = 0;
                    let applicableShowFlag = 0;
                    let sourceShowFlag = 0;
                    return (
                      <>
                        {queryGroupOrderList.map((queryGroupOrder) => {
                          if (queryGroupOrder === "status" && showStatus) {
                            return (
                              <section className="classify drawer">
                                <h3 className="secHead3">
                                  {t("jumper.common.limiter.status")}
                                </h3>
                                <div className="tray">
                                  <ul>
                                    {statusItem.trial &&
                                      !sourceFilterList.includes("4") && (
                                        <li>
                                          <a
                                            tabIndex="0"
                                            href="javascript:;"
                                            onClick={this.setFilter.bind(
                                              this,
                                              "source",
                                              "4",
                                            )}
                                            onKeyDown={(e) => {
                                              if (e.key === "Enter") {
                                                this.setFilter(
                                                  "source",
                                                  "4",
                                                  e,
                                                );
                                              }
                                            }}>
                                            {t("jumper.common.limiter.trial")}
                                          </a>
                                        </li>
                                      )}
                                    {statusItem.news &&
                                      !sourceFilterList.includes("news") && (
                                        <li>
                                          <a
                                            tabIndex="0"
                                            href="javascript:;"
                                            onClick={this.setFilter.bind(
                                              this,
                                              "source",
                                              "news",
                                            )}
                                            onKeyDown={(e) => {
                                              if (e.key === "Enter") {
                                                this.setFilter(
                                                  "source",
                                                  "news",
                                                  e,
                                                );
                                              }
                                            }}>
                                            {t("jumper.common.limiter.news")}
                                          </a>
                                        </li>
                                      )}
                                    {statusItem.order &&
                                      !sourceFilterList.includes("2") && (
                                        <li>
                                          <a
                                            tabIndex="0"
                                            href="javascript:;"
                                            onClick={this.setFilter.bind(
                                              this,
                                              "source",
                                              "2",
                                            )}
                                            onKeyDown={(e) => {
                                              if (e.key === "Enter") {
                                                this.setFilter(
                                                  "source",
                                                  "2",
                                                  e,
                                                );
                                              }
                                            }}>
                                            {t("jumper.common.limiter.order")}
                                          </a>
                                        </li>
                                      )}
                                    {statusItem.free &&
                                      !sourceFilterList.includes("1") && (
                                        <li>
                                          <a
                                            tabIndex="0"
                                            href="javascript:;"
                                            onClick={this.setFilter.bind(
                                              this,
                                              "source",
                                              "1",
                                            )}
                                            onKeyDown={(e) => {
                                              if (e.key === "Enter") {
                                                this.setFilter(
                                                  "source",
                                                  "1",
                                                  e,
                                                );
                                              }
                                            }}>
                                            {t("jumper.common.limiter.free")}
                                          </a>
                                        </li>
                                      )}
                                    {statusItem.core &&
                                      !sourceFilterList.includes("core") && (
                                        <li>
                                          <a
                                            tabIndex="0"
                                            href="javascript:;"
                                            onClick={this.setFilter.bind(
                                              this,
                                              "source",
                                              "core",
                                            )}
                                            onKeyDown={(e) => {
                                              if (e.key === "Enter") {
                                                this.setFilter(
                                                  "source",
                                                  "core",
                                                  e,
                                                );
                                              }
                                            }}>
                                            {t("jumper.common.limiter.core")}
                                          </a>
                                        </li>
                                      )}
                                    {globalConfig[
                                      "jumperrwd.databases.limiter.isPublicLibrary"
                                    ] === "1" &&
                                      !sourceFilterList.includes(
                                        "publicLibrary",
                                      ) && (
                                        <li>
                                          <a
                                            tabIndex="0"
                                            href="javascript:;"
                                            onClick={this.setFilter.bind(
                                              this,
                                              "source",
                                              "publicLibrary",
                                            )}
                                            onKeyDown={(e) => {
                                              if (e.key === "Enter") {
                                                this.setFilter(
                                                  "source",
                                                  "publicLibrary",
                                                  e,
                                                );
                                              }
                                            }}>
                                            {t(
                                              "jumperrwd.common.publicLibrary",
                                            )}
                                          </a>
                                        </li>
                                      )}
                                  </ul>
                                </div>
                              </section>
                            );
                          } else if (
                            queryGroupOrder === "property" &&
                            propertyList !== null &&
                            propertyList !== undefined
                          ) {
                            return (
                              <section className="classify drawer">
                                <h3 className="secHead3">
                                  {t("jumper.common.limiter.property")}
                                </h3>
                                <div className="tray">
                                  <ul>
                                    {(() => {
                                      let propertyDataList = [];
                                      let propertyOut = [];
                                      propertyOut.push(
                                        propertyList.map((property) => {
                                          let propertyData = {
                                            title:
                                              "jumperrwd.property.name." +
                                              property.sn,
                                            cnt: -1,
                                            value: "" + property.sn,
                                          };
                                          propertyDataList.push(propertyData);
                                          if (
                                            !propertyFilterList.includes(
                                              property.sn.toString(),
                                            )
                                          ) {
                                            propertyShowFlag++;
                                            if (propertyShowFlag <= 5) {
                                              return (
                                                <>
                                                  <li>
                                                    <a
                                                      tabIndex="0"
                                                      href="javascript:;"
                                                      onClick={this.setFilter.bind(
                                                        this,
                                                        "property",
                                                        property.sn,
                                                      )}
                                                      onKeyDown={(e) => {
                                                        if (e.key === "Enter") {
                                                          this.setFilter(
                                                            "property",
                                                            property.sn,
                                                            e,
                                                          );
                                                        }
                                                      }}>
                                                      {t(
                                                        "jumperrwd.property.name." +
                                                          property.sn,
                                                      )}
                                                    </a>
                                                  </li>
                                                </>
                                              );
                                            }
                                          }
                                          return "";
                                        }),
                                      );
                                      if (propertyShowFlag > 5) {
                                        propertyOut.push(
                                          <>
                                            <div className="more">
                                              <a
                                                tabIndex="0"
                                                href="javascript:;"
                                                role="button"
                                                title={t(
                                                  "jumperrwd.common.openLightBoxByName",
                                                  {
                                                    name: t(
                                                      "jumperrwd.common.seeMoreAndName",
                                                      {
                                                        moreName: t(
                                                          "jumper.common.limiter.property",
                                                        ),
                                                      },
                                                    ),
                                                  },
                                                )}
                                                aria-label={t(
                                                  "jumperrwd.common.openLightBoxByName",
                                                  {
                                                    name: t(
                                                      "jumperrwd.common.seeMoreAndName",
                                                      {
                                                        moreName: t(
                                                          "jumper.common.limiter.property",
                                                        ),
                                                      },
                                                    ),
                                                  },
                                                )}
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                  this.openResourceGroupLightBox(
                                                    "property",
                                                  );
                                                }}
                                                onKeyDown={(e) => {
                                                  if (e.key === "Enter") {
                                                    this.openResourceGroupLightBox(
                                                      "property",
                                                    );
                                                  }
                                                }}>
                                                {t("jumperrwd.common.seeMore")}
                                              </a>
                                            </div>
                                            <ResourceGroupLightBox2
                                              ref="propertyGroupLightBox"
                                              {...this.props}
                                              title={t(
                                                "jumper.common.limiter.property",
                                              )}
                                              index="property"
                                              data={propertyDataList}
                                              lightboxClass="lightbox resourcesCheck"
                                              blockClass="body"
                                            />
                                          </>,
                                        );
                                      }
                                      return propertyOut;
                                    })()}
                                  </ul>
                                </div>
                              </section>
                            );
                          } else if (
                            queryGroupOrder === "cooperation" &&
                            cooperationList !== null &&
                            cooperationList !== undefined
                          ) {
                            return (
                              <section className="classify drawer">
                                <h3 className="secHead3">
                                  {t("jumper.common.limiter.cooperation")}
                                </h3>
                                <div className="tray">
                                  <ul>
                                    {(() => {
                                      let cooperationDataList = [];
                                      let cooperationOut = [];
                                      cooperationOut.push(
                                        cooperationList.map((cooperation) => {
                                          let cooperationData = {
                                            title:
                                              "jumperrwd.cooperation.name." +
                                              cooperation.sn,
                                            cnt: -1,
                                            value: "" + cooperation.sn,
                                          };
                                          cooperationDataList.push(
                                            cooperationData,
                                          );
                                          if (
                                            !cooperationFilterList.includes(
                                              cooperation.sn.toString(),
                                            )
                                          ) {
                                            cooperationShowFlag++;
                                            if (cooperationShowFlag <= 5) {
                                              return (
                                                <>
                                                  <li>
                                                    <a
                                                      tabIndex="0"
                                                      href="javascript:;"
                                                      onClick={this.setFilter.bind(
                                                        this,
                                                        "cooperation",
                                                        cooperation.sn,
                                                      )}
                                                      onKeyDown={(e) => {
                                                        if (e.key === "Enter") {
                                                          this.setFilter(
                                                            "cooperation",
                                                            cooperation.sn,
                                                            e,
                                                          );
                                                        }
                                                      }}>
                                                      {t(
                                                        "jumperrwd.cooperation.name." +
                                                          cooperation.sn,
                                                      )}
                                                    </a>
                                                  </li>
                                                </>
                                              );
                                            }
                                          }
                                          return "";
                                        }),
                                      );
                                      if (cooperationShowFlag > 5) {
                                        cooperationOut.push(
                                          <>
                                            <div className="more">
                                              <a
                                                tabIndex="0"
                                                href="javascript:;"
                                                role="button"
                                                title={t(
                                                  "jumperrwd.common.openLightBoxByName",
                                                  {
                                                    name: t(
                                                      "jumperrwd.common.seeMoreAndName",
                                                      {
                                                        moreName: t(
                                                          "jumper.common.limiter.cooperation",
                                                        ),
                                                      },
                                                    ),
                                                  },
                                                )}
                                                aria-label={t(
                                                  "jumperrwd.common.openLightBoxByName",
                                                  {
                                                    name: t(
                                                      "jumperrwd.common.seeMoreAndName",
                                                      {
                                                        moreName: t(
                                                          "jumper.common.limiter.cooperation",
                                                        ),
                                                      },
                                                    ),
                                                  },
                                                )}
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                  this.openResourceGroupLightBox(
                                                    "cooperation",
                                                  );
                                                }}
                                                onKeyDown={(e) => {
                                                  if (e.key === "Enter") {
                                                    this.openResourceGroupLightBox(
                                                      "cooperation",
                                                    );
                                                  }
                                                }}>
                                                {t("jumperrwd.common.seeMore")}
                                              </a>
                                            </div>
                                            <ResourceGroupLightBox2
                                              ref="cooperationGroupLightBox"
                                              {...this.props}
                                              title={t(
                                                "jumper.common.limiter.cooperation",
                                              )}
                                              index="cooperation"
                                              data={cooperationDataList}
                                              lightboxClass="lightbox resourcesCheck"
                                              blockClass="body"
                                            />
                                          </>,
                                        );
                                      }
                                      return cooperationOut;
                                    })()}
                                  </ul>
                                </div>
                              </section>
                            );
                          } else if (
                            queryGroupOrder === "applicable" &&
                            applicableList !== null &&
                            applicableList !== undefined
                          ) {
                            return (
                              <section className="classify drawer">
                                <h3 className="secHead3">
                                  {t("jumperrwd.common.applicable")}
                                </h3>
                                <div className="tray">
                                  <ul>
                                    {(() => {
                                      let applicableDataList = [];
                                      let applicableOut = [];
                                      applicableOut.push(
                                        applicableList.map((applicable) => {
                                          let applicableData = {
                                            title:
                                              "jumperrwd.applicable.name." +
                                              applicable.sn,
                                            cnt: -1,
                                            value: "" + applicable.sn,
                                          };
                                          applicableDataList.push(
                                            applicableData,
                                          );
                                          if (
                                            !applicableFilterList.includes(
                                              applicable.sn.toString(),
                                            )
                                          ) {
                                            applicableShowFlag++;
                                            if (applicableShowFlag <= 5) {
                                              return (
                                                <>
                                                  <li>
                                                    <a
                                                      tabIndex="0"
                                                      href="javascript:;"
                                                      onClick={this.setFilter.bind(
                                                        this,
                                                        "applicable",
                                                        applicable.sn,
                                                      )}
                                                      onKeyDown={(e) => {
                                                        if (e.key === "Enter") {
                                                          this.setFilter(
                                                            "applicable",
                                                            applicable.sn,
                                                            e,
                                                          );
                                                        }
                                                      }}>
                                                      {t(
                                                        "jumperrwd.applicable.name." +
                                                          applicable.sn,
                                                      )}
                                                    </a>
                                                  </li>
                                                </>
                                              );
                                            }
                                          }
                                          return "";
                                        }),
                                      );
                                      if (applicableShowFlag > 5) {
                                        applicableOut.push(
                                          <>
                                            <div className="more">
                                              <a
                                                tabIndex="0"
                                                href="javascript:;"
                                                role="button"
                                                title={t(
                                                  "jumperrwd.common.openLightBoxByName",
                                                  {
                                                    name: t(
                                                      "jumperrwd.common.seeMoreAndName",
                                                      {
                                                        moreName: t(
                                                          "jumperrwd.common.applicable",
                                                        ),
                                                      },
                                                    ),
                                                  },
                                                )}
                                                aria-label={t(
                                                  "jumperrwd.common.openLightBoxByName",
                                                  {
                                                    name: t(
                                                      "jumperrwd.common.seeMoreAndName",
                                                      {
                                                        moreName: t(
                                                          "jumperrwd.common.applicable",
                                                        ),
                                                      },
                                                    ),
                                                  },
                                                )}
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                  this.openResourceGroupLightBox(
                                                    "applicable",
                                                  );
                                                }}
                                                onKeyDown={(e) => {
                                                  if (e.key === "Enter") {
                                                    this.openResourceGroupLightBox(
                                                      "applicable",
                                                    );
                                                  }
                                                }}>
                                                {t("jumperrwd.common.seeMore")}
                                              </a>
                                            </div>
                                            <ResourceGroupLightBox2
                                              ref="applicableGroupLightBox"
                                              {...this.props}
                                              title={t(
                                                "jumperrwd.common.applicable",
                                              )}
                                              index="applicable"
                                              data={applicableDataList}
                                              lightboxClass={"filter_lightbox"}
                                              blockClass={"checkblock"}
                                            />
                                          </>,
                                        );
                                      }
                                      return applicableOut;
                                    })()}
                                  </ul>
                                </div>
                              </section>
                            );
                          } else if (
                            queryGroupOrder === "source" &&
                            sourceList !== null
                          ) {
                            return (
                              <section className="classify drawer">
                                <h3 className="secHead3">
                                  {t("jumperrwd.common.source")}
                                </h3>
                                <div className="tray">
                                  <ul>
                                    {(() => {
                                      let sourceDataList = [];
                                      let sourceOut = [];
                                      sourceOut.push(
                                        sourceList.map((source) => {
                                          let sourceData = {
                                            title:
                                              "jumperrwd.source.name." +
                                              source.sn,
                                            cnt: -1,
                                            value: "" + source.sn,
                                          };
                                          sourceDataList.push(sourceData);
                                          if (
                                            !sourceFilterList.includes(
                                              source.sn.toString(),
                                            )
                                          ) {
                                            sourceShowFlag++;
                                            if (sourceShowFlag <= 5) {
                                              return (
                                                <>
                                                  <li>
                                                    <a
                                                      tabIndex="0"
                                                      href="javascript:;"
                                                      onClick={this.setFilter.bind(
                                                        this,
                                                        "source",
                                                        source.sn,
                                                      )}
                                                      onKeyDown={(e) => {
                                                        if (e.key === "Enter") {
                                                          this.setFilter(
                                                            "source",
                                                            source.sn,
                                                            e,
                                                          );
                                                        }
                                                      }}>
                                                      {t(
                                                        "jumperrwd.source.name." +
                                                          source.sn,
                                                      )}
                                                    </a>
                                                  </li>
                                                </>
                                              );
                                            }
                                          }
                                          return "";
                                        }),
                                      );
                                      if (sourceShowFlag > 5) {
                                        sourceOut.push(
                                          <>
                                            <div className="more">
                                              <a
                                                tabIndex="0"
                                                href="javascript:;"
                                                role="button"
                                                title={t(
                                                  "jumperrwd.common.openLightBoxByName",
                                                  {
                                                    name: t(
                                                      "jumperrwd.common.seeMoreAndName",
                                                      {
                                                        moreName: t(
                                                          "jumperrwd.common.source",
                                                        ),
                                                      },
                                                    ),
                                                  },
                                                )}
                                                aria-label={t(
                                                  "jumperrwd.common.openLightBoxByName",
                                                  {
                                                    name: t(
                                                      "jumperrwd.common.seeMoreAndName",
                                                      {
                                                        moreName: t(
                                                          "jumperrwd.common.source",
                                                        ),
                                                      },
                                                    ),
                                                  },
                                                )}
                                                onClick={(e) => {
                                                  e.preventDefault();
                                                  this.openResourceGroupLightBox(
                                                    "source",
                                                  );
                                                }}
                                                onKeyDown={(e) => {
                                                  if (e.key === "Enter") {
                                                    this.openResourceGroupLightBox(
                                                      "source",
                                                    );
                                                  }
                                                }}>
                                                {t("jumperrwd.common.seeMore")}
                                              </a>
                                            </div>
                                            <ResourceGroupLightBox2
                                              ref="sourceGroupLightBox"
                                              {...this.props}
                                              title={t(
                                                "jumperrwd.common.source",
                                              )}
                                              index="source"
                                              data={sourceDataList}
                                              lightboxClass="lightbox resourcesCheck"
                                              blockClass="body"
                                            />
                                          </>,
                                        );
                                      }
                                      return sourceOut;
                                    })()}
                                  </ul>
                                </div>
                              </section>
                            );
                          } else if (
                            queryGroupOrder === "class" &&
                            queryGroupList !== null &&
                            queryGroupList !== undefined
                          ) {
                            return queryGroupList.map((queryGroup) => {
                              let isClose = this.state.closeList.includes(
                                "class:" + queryGroup.index,
                              );
                              return (
                                <>
                                  <section className="classify drawer">
                                    <h3 className="secHead3">
                                      {ReactHtmlParser(
                                        t(
                                          "jumperrwd.class.name." +
                                            queryGroup.index,
                                        ),
                                      )}
                                      <button
                                        type="button"
                                        className={
                                          isClose ? "handle" : "handle closeIt"
                                        }
                                        tabIndex="0"
                                        title={
                                          (isClose ? "展開" : "縮起") +
                                          ReactHtmlParser(
                                            t(
                                              "jumperrwd.class.name." +
                                                queryGroup.index,
                                            ),
                                          )
                                        }
                                        aria-label={
                                          (isClose ? "展開" : "縮起") +
                                          ReactHtmlParser(
                                            t(
                                              "jumperrwd.class.name." +
                                                queryGroup.index,
                                            ),
                                          )
                                        }
                                        onClick={this.changeQueryGroupClose.bind(
                                          this,
                                          isClose,
                                          "class:" + queryGroup.index,
                                        )}></button>
                                    </h3>
                                    {!isClose && (
                                      <div className="tray">
                                        <ul>
                                          {queryGroup.list !== null &&
                                            queryGroup.list !== undefined &&
                                            queryGroup.list.map((list) => {
                                              if (
                                                !classFilterList.includes(
                                                  queryGroup.index +
                                                    ":" +
                                                    list.value,
                                                )
                                              ) {
                                                return (
                                                  <>
                                                    <li>
                                                      <a
                                                        tabIndex="0"
                                                        href="javascript:;"
                                                        onClick={this.setFilter.bind(
                                                          this,
                                                          "class",
                                                          queryGroup.index +
                                                            ":" +
                                                            list.value,
                                                        )}
                                                        onKeyDown={(e) => {
                                                          if (
                                                            e.key === "Enter"
                                                          ) {
                                                            this.setFilter(
                                                              "class",
                                                              queryGroup.index +
                                                                ":" +
                                                                list.value,
                                                              e,
                                                            );
                                                          }
                                                        }}>
                                                        {ReactHtmlParser(
                                                          t(
                                                            "jumperrwd.class.name." +
                                                              list.value,
                                                          ),
                                                        ) +
                                                          "(" +
                                                          list.cnt +
                                                          ")"}
                                                      </a>
                                                    </li>
                                                  </>
                                                );
                                              }
                                              return "";
                                            })}
                                        </ul>
                                      </div>
                                    )}
                                  </section>
                                </>
                              );
                            });
                          }
                          return "";
                        })}
                      </>
                    );
                  }
                  return "";
                }}
              </Query>
            </ApolloProvider>
          )}
          <div
            tabIndex="0"
            onFocus={() => {
              if (this.closeButton) {
                this.closeButton.focus();
              }
            }}
          />
        </div>
      </>
    );
  }
}

export default DBResourceQueryGroupComp2;
